var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11453",
    "data-name": "Group 11453",
    transform: "translate(-232 -18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11452",
    "data-name": "Group 11452",
    transform: "translate(213 -281)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_91",
    "data-name": "Ellipse 91",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(36 313)",
    fill: "#8f8f8f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_92",
    "data-name": "Ellipse 92",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(36 306)",
    fill: "#8f8f8f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_93",
    "data-name": "Ellipse 93",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(36 299)",
    fill: "#8f8f8f"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_4714",
    "data-name": "Line 4714",
    x1: 16,
    transform: "translate(232 19.5)",
    fill: "none",
    stroke: "#8f8f8f",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4715",
    "data-name": "Line 4715",
    x1: 16,
    transform: "translate(232 27)",
    fill: "none",
    stroke: "#8f8f8f",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4716",
    "data-name": "Line 4716",
    x1: 16,
    transform: "translate(232 35)",
    fill: "none",
    stroke: "#8f8f8f",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/ListIcon.24834483a8e9539ea591b15ba0a750a4.svg";
export { ForwardRef as ReactComponent };